import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

// El backend responde { data, state, message }: un fallo de negocio llega con
// state=false y HTTP 200, así que se convierte en excepción para el toast.
const resultado = (data) => {
  if (data?.state === false) throw new Error(data?.message || 'No fue posible completar la acción');
  return data?.data;
};

export const getNominasDirectas = async (params = {}) => {
  const { data } = await axios.get(`${API_URL}/nomina-directa`, { params });
  return resultado(data) || [];
};

export const getNominaDirecta = async (id) => {
  const { data } = await axios.get(`${API_URL}/nomina-directa/${id}`);
  return resultado(data);
};

export const crearNominaDirecta = async (payload) => {
  const { data } = await axios.post(`${API_URL}/nomina-directa`, payload);
  return resultado(data);
};

export const recalcularNominaDirecta = async (id) => {
  const { data } = await axios.post(`${API_URL}/nomina-directa/${id}/recalcular`);
  return resultado(data);
};

export const actualizarDistribucion = async (id, payload) => {
  const { data } = await axios.patch(`${API_URL}/nomina-directa/${id}/distribucion`, payload);
  return resultado(data);
};

export const actualizarLineaDirecta = async (id, lineaId, payload) => {
  const { data } = await axios.patch(`${API_URL}/nomina-directa/${id}/lineas/${lineaId}`, payload);
  return resultado(data);
};

// accion: aprobar | reabrir | pagar | anular
export const cambiarEstadoNominaDirecta = async (id, accion, payload = {}) => {
  const { data } = await axios.post(`${API_URL}/nomina-directa/${id}/${accion}`, payload);
  return resultado(data);
};

export const eliminarNominaDirecta = async (id) => {
  const { data } = await axios.delete(`${API_URL}/nomina-directa/${id}`);
  return resultado(data);
};

export const METODOS_DISTRIBUCION = {
  equitativa: 'Equitativa (partes iguales)',
  porcentaje: 'Por porcentajes',
  kilos: 'Por participación de kilos',
};
